export default "__VITE_ASSET__CcSE21Do__"